import Map from './view/Map';

export { Map };